export function formatExtraPrice(composition, pricing) {
  const participants =
    (composition?.adults ?? 0) + (composition?.childrenBirthdates?.length ?? 0);

  if (pricing?.perPax) {
    return {
      ...pricing,
      price: pricing?.price / participants,
      priceWithoutPromo: pricing?.priceWithoutPromo / participants,
    };
  } else {
    return pricing;
  }
}

// KD-3740 — availability is only checked once real dates and a party are set:
// the list's min-price mode widens the dates to whole months, which is not a
// search either.
export function hasAvailabilitySearch(experienceFilters) {
  return Boolean(
    experienceFilters?.startAt &&
    experienceFilters?.endAt &&
    experienceFilters?.experienceComposition?.length > 0 &&
    !experienceFilters?.searchMinPrice,
  );
}
